import {ActivatedRoute} from '@angular/router';
import {UrlParameters} from '../models/url/url-parameters.model';

export function getUrlParameters(activatedRoute: ActivatedRoute): Promise<UrlParameters> {
    return (new Promise(resolve => {
        let childrenLeft = 0;
        let params: UrlParameters = {};
        const getChildren = (children: ActivatedRoute[]): void => {
            childrenLeft += children.length;
            if (childrenLeft === 0) {
                resolve(params);
            }
            children.forEach(child => {
                if (child.snapshot) {
                    params = { ...params, ...child.snapshot.params, ...child.snapshot.queryParams };
                }
                childrenLeft--;
                getChildren(child.children);
            });
        };
        getChildren(activatedRoute.children);
    }));
}
